export const FETCH_SITE_SNAPSHOTS = 'siteSnapshots/FETCH'
export const RESTORE_SITE_FROM_FILE = 'siteSnapshots/RESTORE_FROM_FILE'
export const RESTORE_SITE_FROM_SNAPSHOT = 'siteSnapshots/RESTORE_FROM_SNAPSHOT'
export const TAKE_SITE_SNAPSHOT = 'siteSnapshots/TAKE_SNAPSHOT'
